import type { AudioCaptureOptions } from 'livekit-client';

export type CaptureProfile = 'personal' | 'shared';
const STORAGE_KEY = 'jabberr.capture-profile';

export function readCaptureProfile(): CaptureProfile {
  try { return localStorage.getItem(STORAGE_KEY) === 'personal' ? 'personal' : 'shared'; }
  catch { return 'shared'; }
}

export function saveCaptureProfile(profile: CaptureProfile): void {
  try { localStorage.setItem(STORAGE_KEY, profile); } catch { /* Session selection still works. */ }
}

/** Shared capture preserves people around one microphone while retaining echo control. */
export function voiceCaptureOptions(profile: CaptureProfile): AudioCaptureOptions {
  return {
    channelCount: 1,
    echoCancellation: true,
    autoGainControl: true,
    noiseSuppression: true,
    voiceIsolation: profile === 'personal',
  };
}

export function captureHint(profile: CaptureProfile): string {
  return profile === 'shared'
    ? 'For people sharing this microphone. Keep each person close enough to be heard.'
    : 'For your own microphone or headset.';
}

export function captureSettings(track: MediaStreamTrack): string {
  const settings = track.getSettings() as MediaTrackSettings & { voiceIsolation?: boolean };
  const flag = (value: boolean | undefined) => value === undefined ? 'not reported' : value ? 'on' : 'off';
  return `Echo control: ${flag(settings.echoCancellation)}; noise suppression: ${flag(settings.noiseSuppression)}; voice isolation: ${flag(settings.voiceIsolation)}`;
}
